import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { CriacaoClassificacaoDTO } from 'model/classificacao/CriacaoClassificacaoDTO';
import { Api } from 'service/api/Api';
import { ApiClassificacao } from "service/api/classificacao/ApiClassificacao";
import { ResponseError } from 'view/component/MensagensErroServidor/ErroServidor.utils';

interface ClassificacaoState {
  data: any[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error?: ResponseError;
  currentClassificacao: any | null;
}

const initialState: ClassificacaoState = {
  data: [],
  status: 'idle',
  error: undefined,
  currentClassificacao: null,
};

export const fetchClassificacoes = createAsyncThunk('classificacao/fetchClassificacoes', async () => {
  return await ApiClassificacao.classificacoes();
});

export const fetchAllClassificacoesByReino = createAsyncThunk('classificacao/fetchAllClassificacoesByReino', async () => {
  return await ApiClassificacao.getClassificacoesByReino();
});

export const addClassificacao = createAsyncThunk('classificacao/addClassificacao', async (classificacao: CriacaoClassificacaoDTO) => {
  classificacao.reinoId = Api.REINO_PADRAO;
  return await ApiClassificacao.adicionar(classificacao);
});

export const updateClassificacaoById = createAsyncThunk('classificacao/updateClassificacao', async (classificacao: CriacaoClassificacaoDTO) => {
  return await ApiClassificacao.atualizar(classificacao.id ?? 0, classificacao);
});

export const deleteClassificacaoById = createAsyncThunk('classificacao/deleteClassificacao', async (id: number) => {
  return await ApiClassificacao.deletar(id);
});

const classificacaoSlice = createSlice({
  name: 'classificacao',
  initialState,
  reducers: {
    setCurrentClassificacao: (state, action: PayloadAction<any>) => {
      state.currentClassificacao = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClassificacoes.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchClassificacoes.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        console.log(action.payload);
      })
      .addCase(fetchClassificacoes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message as ResponseError;
        console.log('fetchClassificacoes.rejected', action.error.message);
      })
      .addCase(deleteClassificacaoById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message as ResponseError;
      })
      .addCase(fetchAllClassificacoesByReino.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllClassificacoesByReino.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchAllClassificacoesByReino.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message as ResponseError;
      })
      .addCase(addClassificacao.fulfilled, (state, action) => {
        state.data.push(action.payload);
      })
      .addCase(updateClassificacaoById.fulfilled, (state, action) => {
        const index = state.data.findIndex((item) => item.id_classificacao === action.payload.id_classificacao);
        state.data[index] = action.payload;
      })
      .addCase(deleteClassificacaoById.fulfilled, (state, action) => {
        state.data = state.data.filter((item) => item.id_classificacao !== action.payload.id_classificacao);
      });
  },
});

export default classificacaoSlice.reducer;

